import script from "./sf-indicator-new-comms.ce.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-indicator-new-comms.ce.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./sf-indicator-new-comms.ce.vue?vue&type=style&index=0&id=766c45cf&inline&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]]])

export default __exports__